import React, { useContext, useState } from 'react';
import * as S from './styled';
import Form from '../..';
import { ValidityContext } from '../../../../provider/ValidityProvider';
import {
  defaultBlurValidityStatusForm,
  defaultValidityStatusForm,
} from '../../../../store/validity/utils';
import ColorPalette from '../../../ColorPalette';

export default function FormStatusCreate() {
  const {
    statuses,
    validateForm,
    getFormMessage,
    getValidity,
    setValidity,
    enqueueSnackbar,
    createValidityStatus,
    setModal,
    filterValidityStatus,
  } = useContext(ValidityContext)!.controllers.status;
  const form = getValidity(`forms.status.create`);

  const blurField = (field: keyof ValidityStatusForm) => () => {
    setValidity(`blur.status.create.${field}`, true);
  };

  const messages = getFormMessage('status.create');

  const clearForm = () => {
    const statusForm = defaultValidityStatusForm();
    setValidity(`forms.status.create`, statusForm);
    setValidity(`blur.status.create`, defaultBlurValidityStatusForm());
  };

  const [createLoading, setCreateLoading] = useState(false);
  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setCreateLoading(true);
    validateForm('status.create')
      .then(() => {
        createValidityStatus()
          .then((status) => {
            setValidity(`filters.status.data.data`, [...statuses, status]);
            clearForm();
            setModal('single.createStatus', false);
            setTimeout(() => {
              filterValidityStatus();
            }, 1000);
            enqueueSnackbar('Status criado com sucesso', {
              variant: 'success',
            });
          })
          .catch(() => {
            enqueueSnackbar('Houve uma falha ao criar o status', {
              variant: 'error',
            });
          })
          .finally(() => {
            setCreateLoading(false);
          });
      })
      .catch(() => {
        enqueueSnackbar('Verifique a validade dos campos', {
          variant: 'error',
        });
        setCreateLoading(false);
      });
  };
  return (
    <S.Form
      style={{
        maxHeight: '80vh',
      }}
      onSubmit={onSubmit}
    >
      <S.Body>
        <S.Grid>
          <Form.Input
            label="Nome"
            value={form.name}
            onChange={(e) => {
              setValidity('forms.status.create.name', e.target.value);
            }}
            error={messages.name}
            onBlur={blurField('name')}
          />
          <ColorPalette
            value={form.color}
            onChange={(color) => {
              setValidity('forms.status.create.color', color);
            }}
          />
        </S.Grid>
      </S.Body>
      <S.Actions>
        <Form.Button type="button" onClick={clearForm}>
          Limpar
        </Form.Button>
        <Form.Button loading={createLoading}>Criar</Form.Button>
      </S.Actions>
    </S.Form>
  );
}
